import { useWindowSize } from "react-use";
import { useEffect, useState } from "react";

export const useIsFirstNameHidden = () => {
    const { width } = useWindowSize();

    const [isHidden, setIsHidden] = useState(false);

    useEffect(() => {
        setIsHidden(width <= 450);
    }, [width]);

    return isHidden;
};
